import { TRACK } from 'config/api-routes';
import { HomeFeedEngine } from 'types/product.types';
import { POST } from 'utils/request';

export type SearchContext = 'user_search' | 'category_browse' | 'brand_browse';

export type TrackSearchPayload = {
  searchGuid: string;
  searchContext?: SearchContext;
  searchEngine?: string;
  query: string | null;
  filters?: {
    categories?: number[];
    brands?: number[];
    sizes?: string[];
    conditions?: number[];
    colors?: number[];
    materials?: number[];
    price?: { min?: number; max?: number };
  };
  auto?: boolean;
};

export type TrackProductViewPayload = {
  product: { id: number; slug: string };
  searchGuid?: string;
  recommendationId?: string;
  /** Feed arm that served the card. Sent on every feed click/view; only the advec arm issues ids. */
  recommendationEngine?: HomeFeedEngine;
  isOwnProduct?: boolean;
};

/**
 * A click carries at most one origin: searchGuid for a search result, recommendationId for a card
 * from the personalised feed. The API rejects a click carrying both. A feed click on the control
 * or yaga-search arm carries no origin id — recommendationEngine is what attributes it to an arm.
 */
export type TrackProductSelectPayload = TrackProductViewPayload & {
  rank: number;
};

const fireAndForget = (promise: Promise<unknown>): void => {
  promise.catch(() => undefined);
};

export const RecsysTracking = {
  search(payload: TrackSearchPayload): void {
    fireAndForget(POST(TRACK.SEARCH.POST(), payload, { silentFail: true }));
  },
  productView(payload: TrackProductViewPayload): void {
    fireAndForget(POST(TRACK.PRODUCT_VIEW.POST(), payload, { silentFail: true }));
  },
  productSelect(payload: TrackProductSelectPayload): void {
    fireAndForget(POST(TRACK.PRODUCT_SELECT.POST(), payload, { silentFail: true }));
  },
};
